import { generateEventId, urlify } from '../../utils/string';
import { prefix } from '../../utils/locale';

const viewAnalytics = (price, product, setup, fromList = {}) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const uniqueEventID = generateEventId();

	window.dataLayer.push({ values: null });
	window.dataLayer.push({
		event: 'ViewContent',
		event_id: uniqueEventID,
		values: {
			value: price.priceAsNumber,
			currency: setup.countries[setup.country].currency,
			content_name: product.name,
			content_type: 'product_group',
			content_ids: [product.product],
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'ViewContentGA',
		ecommerce: {
			detail: {
				actionField: { list: fromList[product.product] || '' },
				products: [{
					name: product.name,
					id: product.product,
					sku: product.productSku,
					price: price.priceAsNumber,
					brand: product.brandName,
					category: product.canonicalUri.slice(0, product.canonicalUri.lastIndexOf('/')),
					variant: product.variantName,
				}],
			},
		},
	});

	const itemCategory = product.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'view_item',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency: setup.countries[setup.country].currency,
			items: [{
				item_name: product.name,
				item_id: product.product,
				price: price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				item_brand: product.brandName,
				...itemCategory,
				item_list_id: urlify(fromList[product.product] || ''),
				item_list_name: fromList[product.product] || '',
				item_variant: product.variantName,
				quantity: '1',
			}],
		},
	});

	if (typeof window._learnq === 'undefined') window._learnq = []; // eslint-disable-line no-underscore-dangle
	window._learnq.push(['track', 'Viewed Product', { // eslint-disable-line no-underscore-dangle
		ProductName: product.name,
		ProductID: product.product,
		SKU: product.productSku,
		Categories: product.canonicalUri.split('/').slice(0, -1),
		ImageURL: product.media?.[0] || '',
		URL: `${window.location.origin}${prefix(setup, product.canonicalUri)}`,
		Brand: product.brandName,
		Price: price.priceAsNumber,
		CompareAtPrice: price.priceBeforeDiscountAsNumber,
	}]);

	window._learnq.push(['trackViewedItem', { // eslint-disable-line no-underscore-dangle
		Title: product.name,
		ItemId: product.product,
		Categories: product.canonicalUri.split('/').slice(0, -1),
		ImageUrl: product.media?.[0] || '',
		Url: `${window.location.origin}${prefix(setup, product.canonicalUri)}`,
		Metadata: {
			Brand: product.brandName,
			Price: price.priceAsNumber,
			CompareAtPrice: price.priceBeforeDiscountAsNumber,
		},
	}]);
};

export default viewAnalytics;
